import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import SubsidiaryService from '../../../../shared/services/subsidiary/subsidiary.service';
import { IPostSubsidiary } from '../../../../shared/services/subsidiary/subsidiary.model';
import { SubsidiaryForm } from '../../../presentation-components/organisation-components/subsidiary-form';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';

export const OrganisationSubsidiaryNewPage = () => {
  const navigate = useNavigate();
  //Services
  const userNotificationsContext = useContext(UserNotificationsContext)
  const subsidiaryService = SubsidiaryService.getInstance()
  //Context
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>()
  const [errorCode, setErrorCode] = useState<number>()
  const [editField, setEditField] = useState<string>('')
  const [newSubsidiary, setNewSubsidiary] = useState<IPostSubsidiary>({
    name: '',
    subsidiaryReference: '',
    countryId: 'GBR',
    defaultConversionSourceId: '5c7f57de-5209-4851-bd5e-eb1bb0e5273c',
    isPrimary: false,
    customFieldValues: [],
    defaultSpendBasedConversionSourceId: '54689eb6-608e-41f7-84d8-c76974d55550',
  })
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false)

  const submitHandler = (value: IPostSubsidiary) => {
    if (!isFormSubmitting) {
      setErrorMessage('')
      setIsFormSubmitting(true)
      subsidiaryService.create(value)
        .then(response => {
          setIsFormSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
          subsidiaryService.getAll(true).catch(() => {})
          navigate(`/organisation/subsidiaries/${response.id}`)
        })
        .catch(err => {
          setIsFormSubmitting(false)
          console.log(err)
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
        })
    }
  }

  return (
    <PageOuterContainer>
      {<PageHeading
        title={`Create New ${screenLabelsContext.getLabel('subsidiary', { plural: false, capitalize: 'first' })}`}
        includeBackButton={true}
        backButtonLink='/organisation/subsidiaries'
        backButtonText={`Back to ${screenLabelsContext.getLabel('subsidiary', { plural: true, capitalize: 'first' })}`}
        hasTabs={false}
      />}
      <SubsidiaryForm
        onSubmit={submitHandler}
        isEditPage={false}
        subsidiary={newSubsidiary}
        setEditField={setEditField}
        editField={editField}
        errorMessage={errorMessage}
        errorCode={errorCode}
        isSubmitting={isFormSubmitting}
        setErrorMessage={setErrorMessage}
        setErrorCode={setErrorCode}
      />
    </PageOuterContainer>
  )
}